import * as z from "zod";

export const startBalanceReload = {
  name: "startBalanceReload" as const,
  input: z.object({}),
  output: z.object({ balance: z.string() }),
};
